// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.searchable-column-list-container {
    margin-top: 10px;
    margin-bottom: 15px;
    max-width: 400px; 
  }
  
  .column-search-input {
    width: 100%;
    padding: 8px 10px;
    border: 1px solid #ccc;
    border-radius: 4px;
    box-sizing: border-box; /* Include padding and border in width */
    margin-bottom: 8px;
    font-size: 14px;
  }
  
  .column-search-input:disabled {
    background-color: #f2f2f2;
    cursor: not-allowed;
  }
  
  
  .column-list {
    list-style: none;
    padding: 0;
    margin: 0;
    overflow-y: auto; /* Vertical scrollbar */
    border: 1px solid #eee;
    border-radius: 4px;
  }
  
  .column-list-item {
    padding: 8px 12px;
    cursor: pointer;
    border-bottom: 1px solid #f0f0f0;
    font-size: 14px;
    white-space: nowrap; /* Keep text on a single line */
    overflow: hidden; /* Hide overflowed text */
    text-overflow: ellipsis; /* Show '...' for overflowed text */
    transition: background-color 0.2s ease;
  }
  
  .column-list-item:last-child {
    border-bottom: none;
  }
  
  .column-list-item:hover:not(.disabled) {
    background-color: #f9f9f9;
  }
  
  .column-list-item.selected:not(.disabled) {
    background-color: #e0efff;
    font-weight: 500;
  }
  
  .column-list-item.disabled {
    color: #aaa;
    cursor: not-allowed;
    background-color: #fafafa;
  }

  .column-list-item.locked {
    color: #000000;
    cursor: not-allowed;
    background-color: #fafafa;
  }
  
  .column-list-item-no-results {
    padding: 8px 12px;
    color: #888;
    font-style: italic;
    font-size: 14px;
  }
  
  .info-text-small {
    font-size: 12px;
    color: #666;
    margin-top: -5px;
    margin-bottom: 5px;
  }`, "",{"version":3,"sources":["webpack://./src/css/SearchableColumnList.css"],"names":[],"mappings":"AAAA;IACI,gBAAgB;IAChB,mBAAmB;IACnB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,iBAAiB;IACjB,sBAAsB;IACtB,kBAAkB;IAClB,sBAAsB,EAAE,wCAAwC;IAChE,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,yBAAyB;IACzB,mBAAmB;EACrB;;;EAGA;IACE,gBAAgB;IAChB,UAAU;IACV,SAAS;IACT,gBAAgB,EAAE,uBAAuB;IACzC,sBAAsB;IACtB,kBAAkB;EACpB;;EAEA;IACE,iBAAiB;IACjB,eAAe;IACf,gCAAgC;IAChC,eAAe;IACf,mBAAmB,EAAE,+BAA+B;IACpD,gBAAgB,EAAE,yBAAyB;IAC3C,uBAAuB,EAAE,mCAAmC;IAC5D,sCAAsC;EACxC;;EAEA;IACE,mBAAmB;EACrB;;EAEA;IACE,yBAAyB;EAC3B;;EAEA;IACE,yBAAyB;IACzB,gBAAgB;EAClB;;EAEA;IACE,WAAW;IACX,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,cAAc;IACd,mBAAmB;IACnB,yBAAyB;EAC3B;;EAEA;IACE,iBAAiB;IACjB,WAAW;IACX,kBAAkB;IAClB,eAAe;EACjB;;EAEA;IACE,eAAe;IACf,WAAW;IACX,gBAAgB;IAChB,kBAAkB;EACpB","sourcesContent":[".searchable-column-list-container {\n    margin-top: 10px;\n    margin-bottom: 15px;\n    max-width: 400px; \n  }\n  \n  .column-search-input {\n    width: 100%;\n    padding: 8px 10px;\n    border: 1px solid #ccc;\n    border-radius: 4px;\n    box-sizing: border-box; /* Include padding and border in width */\n    margin-bottom: 8px;\n    font-size: 14px;\n  }\n  \n  .column-search-input:disabled {\n    background-color: #f2f2f2;\n    cursor: not-allowed;\n  }\n  \n  \n  .column-list {\n    list-style: none;\n    padding: 0;\n    margin: 0;\n    overflow-y: auto; /* Vertical scrollbar */\n    border: 1px solid #eee;\n    border-radius: 4px;\n  }\n  \n  .column-list-item {\n    padding: 8px 12px;\n    cursor: pointer;\n    border-bottom: 1px solid #f0f0f0;\n    font-size: 14px;\n    white-space: nowrap; /* Keep text on a single line */\n    overflow: hidden; /* Hide overflowed text */\n    text-overflow: ellipsis; /* Show '...' for overflowed text */\n    transition: background-color 0.2s ease;\n  }\n  \n  .column-list-item:last-child {\n    border-bottom: none;\n  }\n  \n  .column-list-item:hover:not(.disabled) {\n    background-color: #f9f9f9;\n  }\n  \n  .column-list-item.selected:not(.disabled) {\n    background-color: #e0efff;\n    font-weight: 500;\n  }\n  \n  .column-list-item.disabled {\n    color: #aaa;\n    cursor: not-allowed;\n    background-color: #fafafa;\n  }\n\n  .column-list-item.locked {\n    color: #000000;\n    cursor: not-allowed;\n    background-color: #fafafa;\n  }\n  \n  .column-list-item-no-results {\n    padding: 8px 12px;\n    color: #888;\n    font-style: italic;\n    font-size: 14px;\n  }\n  \n  .info-text-small {\n    font-size: 12px;\n    color: #666;\n    margin-top: -5px;\n    margin-bottom: 5px;\n  }"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
